(() => {
  if (window.CHImageScroll) {
    window.CHImageScroll.refresh(document);
    return;
  }

  const frames = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let requestedFrame;

  const requestUpdate = () => {
    if (requestedFrame) return;
    requestedFrame = window.requestAnimationFrame(update);
  };

  const refresh = (root) => {
    if (root.matches?.('[data-ch-image-scroll]')) frames.add(root);
    root.querySelectorAll?.('[data-ch-image-scroll]').forEach((frame) => frames.add(frame));
    requestUpdate();
  };

  const update = () => {
    requestedFrame = undefined;

    frames.forEach((frame) => {
      if (!frame.isConnected) {
        frames.delete(frame);
        return;
      }

      if (reducedMotion.matches) {
        frame.style.removeProperty('--image-scroll-y');
        return;
      }

      const measuringElement = frame.hasAttribute('data-ch-image-scroll-self') ? frame.parentElement || frame : frame;
      const rect = measuringElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
      const distance = Number.parseFloat(getComputedStyle(frame).getPropertyValue('--image-scroll-distance')) || 25;
      const offset = (progress - 0.5) * distance * 2;

      frame.style.setProperty('--image-scroll-y', `${offset.toFixed(2)}px`);
    });
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reducedMotion.addEventListener('change', requestUpdate);
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));

  window.CHImageScroll = { refresh };
  refresh(document);
})();
